import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { createBrowserRouter } from "react-router-dom";
import useURL from "shared/welda/hooks/useURL";
import ErrorBoundary from "../components/error/ErrorBoundary";
import useLoadingOverlay from "../hooks/useLoadingOverlay";
import AppLayout from "../layouts/AppLayout";
import {
  requireClient,
  requireEmployee,
  withClientState,
  withUserState,
} from "./routeProtection";
import {
  intranetNotFoundRoute,
  intranetProtectedRoutes,
  intranetPublicRoutes,
  lazyRouteElement,
  websiteNotFoundRoute,
  websiteProtectedRoutes,
  websitePublicRoutes,
} from "./routes";

const useWeldaPortalRoutes = () => {
  const [routes, setRoutes] = useState([]);
  const { URLDomain, URLPrefix } = useURL();

  const {
    client: reduxClient,
    user: reduxUser,
    isLoading,
  } = useSelector((state) => state.users);

  useLoadingOverlay({
    isLoading: isLoading && !reduxUser && !reduxClient,
    loadingReason: `Gebruikergegevens ophalen`,
  });

  // NOTE: The code below is necessary because even though the routes are protected, the code would still be added to the bundle
  // NOTE: With SSR, this would not be needed, as we could only server the routes that the user has access to
  const createRoutes = useCallback(() => {
    setRoutes((currentRoutes) => {
      if (currentRoutes.length > 0) {
        return currentRoutes;
      }

      return [
        {
          path: `${URLPrefix}`,
          element: lazyRouteElement(() => import("webshop/layouts/WebsiteLayout")),
          children: [
            ...websitePublicRoutes,
            {
              loader: withClientState(requireClient),
              children: websiteProtectedRoutes,
            },
            websiteNotFoundRoute,
          ],
        },
        // Voeg intranet-routes alleen toe als het NIET via awtech.be is
        ...(URLDomain !== ""
          ? [
            ...intranetPublicRoutes,
            {
              path: "",
              loader: withUserState(requireEmployee),
              children: [...intranetProtectedRoutes],
            },
            intranetNotFoundRoute,
          ]
          : []),
      ];
    });
  }, [URLDomain, URLPrefix]);

  const browserRouter = createBrowserRouter([
    {
      element: <AppLayout />,
      errorElement: <ErrorBoundary />,
      loader: withUserState(null), // Restored - provides user context to layout
      children: routes,
    },
  ]);

  return { createRoutes, browserRouter };
};

export default useWeldaPortalRoutes;
